import React from "react";
import BCreditRiskIndicator from "./BCreditRiskIndicator";
import BCreditRiskTrackerDetails from "./BCreditRiskTrackerDetails";
import { BusinessCreditReportStatePII } from "../../../store/businessCreditReportService/types";
import { Link } from "react-router-dom";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";

interface IProps {
    reportObject: BusinessCreditReportStatePII;
    showDetails: boolean;
    view: string;
}

const BCreditNotRated: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            <div className={props.view === "score" ? "box offset-padding" : props.view === "dashboard" ? "box" : ""}>
                <div className="box-header">
                    {props.view === "report" ? (
                        <div className="row full-width between-xs margin-bottom-l payment-table-header">
                            <div className="col-xs flex-grow-null">
                                <h4 className="content-sub-title">Credit Risk Class</h4>
                            </div>
                        </div>
                    ) : (
                        <React.Fragment>
                            <div className="box-title-container">
                                {props.view === "score" && (
                                    <div className="box-title-icon" aria-hidden="true">
                                        <RenderIcons iconName="chart-line" />
                                    </div>
                                )}
                                <div className="box-title-text">
                                    <h2 className="box-title" id="credit-score-trend-title">
                                        Credit Risk Class History
                                    </h2>
                                </div>
                            </div>
                            {(props.showDetails === false || props.view === "dashboard") && (
                                <div className="box-actions">
                                    <Link to="/credit/score" className="default_link">
                                        Find out more
                                    </Link>
                                </div>
                            )}
                        </React.Fragment>
                    )}
                </div>
                <div className={props.view !== "score" ? "flex-row graphics-container " + props.view : "box-content graphics-container"}>
                    {props.view !== "score" && <BCreditRiskIndicator reportObject={props.reportObject} view={"NR"} isBankrupt={false} />}
                    <div className={"credit-score-trend-chart not-rated"}>
                        <div id="chart-credit-trend" className="m-chart-container">
                            <div className="graph-label">Your profile doesn't include any past credit ratings at this time</div>
                        </div>
                    </div>

                    {props.view !== "dashboard" && props.showDetails && (
                        <React.Fragment>
                            <BCreditRiskTrackerDetails reportObject={props.reportObject} />
                        </React.Fragment>
                    )}
                </div>
                {props.view === "dashboard" && props.showDetails && (
                    <React.Fragment>
                        <BCreditRiskTrackerDetails reportObject={props.reportObject} />
                    </React.Fragment>
                )}
            </div>
        </React.Fragment>
    );
};
export default BCreditNotRated;
